import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { useNavigate } from 'react-router-dom';

interface DictionaryBoxProps {
	count?: number;
	title: string;
	context: string;
	imageUrl?: string;
	fullContent?: boolean;
}

export default function DictionaryBox({
	count,
	title,
	context,
	imageUrl,
	fullContent = false,
}: DictionaryBoxProps) {
	const navigate = useNavigate();

	if (!fullContent) {
		context = context.replace(imageUrl ? imageUrl : '', '');
		context = context.slice(0, 200) + '...';
	}

	const handleClick = () => {
		if (!fullContent) {
			navigate(`/diagnosis/dictionary/${title}`);
		}
	};

	return (
		<BoxLayout onClick={handleClick}>
			<Right>
				{count && (
					<Count imageUrl={imageUrl}>
						<CountText>{count}</CountText>
					</Count>
				)}
				<Title>
					<TitleText>{title}</TitleText>
					<ConText>
						<ReactMarkdown>{context}</ReactMarkdown>
					</ConText>
				</Title>
			</Right>
			{!fullContent && <RightIcon src="/icons/right.svg" />}
		</BoxLayout>
	);
}
const Right = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
	@media (max-width: 768px) {
		flex-direction: column;

		gap: 20px;
	}
`;
const Title = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
const TitleText = styled.span`
	color: #000;
	font-size: 30px;
	font-style: normal;
	font-weight: 700;
	@media (max-width: 768px) {
		font-size: 24px;
	}
`;
const ConText = styled.span`
	color: #777;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	@media (max-width: 768px) {
		font-size: 16px;
	}
`;
const BoxLayout = styled.div<{ imageUrl?: string }>`
	display: flex;
	width: 100%;
	padding: 30px 125px;
	gap: 20px;
	justify-content: space-between;
	align-items: center;
	background-color: white;
	margin-bottom: 30px;
	background-size: cover;
	background-position: center;
	backdrop-filter: blur(10px);
	background-blend-mode: darken;
	@media (max-width: 768px) {
		flex-direction: column;
		padding: 20px;
	}
	cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;
const Count = styled.div<{ imageUrl?: string }>`
	position: relative;
	display: flex;
	min-width: 150px;
	min-height: 150px;
	justify-content: center;
	align-items: center;
	border-radius: 25px;
	background: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : '#29c472')};
	background-size: cover;
	background-position: center;
	backdrop-filter: brightness(0.7);
	@media (max-width: 768px) {
		width: 80px;
		height: 80px;
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 25px;
		background: inherit;
		filter: brightness(0.7);
		z-index: -1;
	}
`;
const CountText = styled.span`
	color: #fff;
	font-family: Pretendard;
	font-size: 50px;
	font-style: normal;
	font-weight: 500;
	@media (max-width: 768px) {
		font-size: 40px;
	}
`;
const RightIcon = styled.img`
	width: 20px;
	@media (max-width: 768px) {
		display: none;
	}
`;
